<template>
  <v-app>
    <v-app-bar app color="primary" dark v-if="isLoaded">
      <v-toolbar-title style="cursor: pointer" @click="onTitleClick">{{siteName}} </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="ps"
        v-if="isNotGuest"
        hide-details
        append-icon="mdi-magnify"
        single-line
        @keydown.enter="submit"
        @click:append="submit"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn icon v-on:click="jumpToMessageInbox()">
        <v-icon>mdi-message-alert-outline</v-icon>
      </v-btn>
      <v-btn icon v-on:click="search()">
        <v-icon>mdi-card-search-outline</v-icon>
      </v-btn>
      <v-btn icon v-if="isAdmin" v-on:click="onB()">
        <v-icon>mdi-cog-outline</v-icon>
      </v-btn>
      <v-menu
        v-model="menu"
        :nudge-width="150"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list dense>
            <v-list-item>
              <v-list-item-title>{{ getRole }}</v-list-item-title>
            </v-list-item>
            <v-divider class="my-0"></v-divider>
            <v-list-item-group v-model="selectedItem" color="primary">
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
                v-on:click="onA(item.action)"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>
    <v-footer app>
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} - <strong>PSS-Group</strong>
      </v-col>
    </v-footer>

  </v-app>
</template>

<script>

export default {
  name: 'App',
  computed: {
    isLoaded() {
      return this.$store.state.loaded;
    },
    isAdmin() {
      return this.$store.state.user.role === '管理員';
    },
    isNotGuest() {
      return this.$store.state.user.role !== '遊客';
    },
    getRole() {
      return this.$store.state.user.role;
    },
    siteName() {
      return this.$store.state.siteName;
    },
  },
  data() {
    return {
      ps: '',
      menu: false,
      selectedItem: -1,
      items: [
        { text: '登出', icon: 'mdi-logout', action: 'logout'},
      ],
    };
  },
  methods: {
    onTitleClick() {
      if (this.$store.state.user.role === '遊客') {
        this.$router.push({ path: 'search' });
      } else {
        this.$router.push({ path: 'home' });
      }
    },
    onA(action) {
      if (action === 'logout') {
        this.axios.post('api/logout');
        this.$store.commit('ClearAuth');
        this.$router.push({ path: 'login' });
        this.menu = false;
      }
    },
    onB() {
      this.$router.push({ path: 'setting' });
    },
    search() {
      this.$router.push({ path: 'search' });
    },
    jumpToMessageInbox() {
      this.$router.push({ path: 'messageInbox' });
    },
    submit() {
      this.$store.commit('SetPS', { id: this.ps, code: this.ps });
      const routeData = this.$router.resolve({ name: 'ps', query: { id: this.ps, code: this.ps } });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style scoped>
  /* @media print {
    body * {
      visibility:hidden;
    }
  } */
</style>
